import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { TemaRuntimeService } from '../../../auxiliares/servicios/tema-runtime.service';

@Component({
  selector: 'app-settings-modal',
  templateUrl: './app-settings.component.html',
  styleUrls: ['./app-settings.component.scss'],
  standalone: false,
})
export class AppSettingsComponent {
  dialogRef = inject<MatDialogRef<AppSettingsComponent>>(MatDialogRef);
  helper = inject(HelperService);
  private temaRuntime = inject(TemaRuntimeService);

  toggleTheme() {
    this.helper.toggleTheme();
  }

  toggleEfectosFestivos() {
    const ahoraDesactivado = this.temaRuntime.overlayDesactivadoPorUsuario();
    this.temaRuntime.setOverlayDesactivado(!ahoraDesactivado);
  }

  toggleMapa3D() {
    this.helper.toggleMapa3D();
  }

  toggleMapaDiaNoche() {
    this.helper.toggleMapaDiaNoche();
  }

  toggleMapaOscuro() {
    this.helper.toggleMapaOscuro();
  }

  toggleMapaPOIs() {
    this.helper.toggleMapaPOIs();
  }

  toggleMapaTrafico() {
    this.helper.toggleMapaTrafico();
  }

  toggleSonido() {
    this.helper.toggleSonido();
  }

  get efectosFestivosActivos(): boolean {
    return !this.temaRuntime.overlayDesactivadoPorUsuario();
  }

  get mapa3DEnabled(): boolean {
    return this.helper.mapa3DEnabled;
  }

  get mapaDiaNocheEnabled(): boolean {
    return this.helper.mapaDiaNocheEnabled;
  }

  get mapaOscuroEnabled(): boolean {
    return this.helper.mapaOscuroEnabled;
  }

  get mapaPOIsEnabled(): boolean {
    return this.helper.mapaPOIsEnabled;
  }

  get mapaTraficoEnabled(): boolean {
    return this.helper.mapaTraficoEnabled;
  }

  get sonidoMuteado(): boolean {
    return this.helper.sonidoMuteado;
  }
}
